export const options = [
    {
        value: "move",
        option: "Move to..."
    },
    {
        value: "currentlyReading",
        option: "Currently Reading"
    },
    {
        value: "wantToRead",
        option: "Want to Read"
    },
    {
        value: "read",
        option: "Read"
    },
    {
        value: "none",
        option: "None"
    }
];